import React from "react"
import ReactDOM from "react-dom"
import HotspotBanner from "./component/HotspotBanner"

export default class HotspotModule {
  constructor(elem) {
    this.elem = elem
    this.dotsElem = elem.parentElement.querySelector(".js-hotspot-dots")

    this.spots = JSON.parse(elem.dataset.spots || "{}")
    this.mobileSpots = JSON.parse(elem.dataset.mobileSpots || "{}")
    this.dimensions = { x: this.elem.offsetWidth, y: this.elem.offsetHeight }

    this.init()
    return this
  }

  init() {
    ReactDOM.unmountComponentAtNode(this.elem)
    ReactDOM.render(<HotspotBanner spots={this.spots} mobileSpots={this.mobileSpots} dimensions={this.dimensions} />, this.dotsElem)
  }
}
